import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

// existing offer
export const getOrderItemOffer = (
  storeId,
  storeCustomerId,
  orderId,
  orderItemId,
) => {
  return axios({
    method: 'get',

    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/order-item/' +
      orderItemId +
      '/offer',
    headers: getHeaders(),
  });
};

// all offer of garment service
export const getOrderItemGarmentServiceOffer = (
  storeId,
  storeCustomerId,
  orderId,
  orderItemId,
) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/order-item/' +
      orderItemId +
      '/garment-service-offer',
    headers: getHeaders(),
  });
};

export const addOrderItemOffer = (
  storeId,
  storeCustomerId,
  orderId,
  orderItemId,
  data,
) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/order-item/' +
      orderItemId +
      '/offer',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const deleteAllOrderItemOffer = (
  storeId,
  storeCustomerId,
  orderId,
  orderItemId,
) => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/order-item/' +
      orderItemId +
      '/offer',
    headers: getHeaders(),
  });
};

export const deleteSingleOfferOrderItem = (
  storeId,
  storeCustomerId,
  orderId,
  orderItemId,
  offerId,
) => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/order-item/' +
      orderItemId +
      '/offer/' +
      offerId,
    headers: getHeaders(),
  });
};

export const getOrderItemGarmentServicePrice = (
  storeId,
  storeCustomerId,
  priceListId,
) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/garment-category-service-price/' +
      priceListId,
    headers: getHeaders(),
  });
};

// get order/{orderId}/order-item/{orderItemId}/offer

// get order/{orderId}/order-item/{orderItemId}/garment-service-offer

// Offer add [POST] :  order/{orderId}/order-item/{orderItemId}/offer
// payload is same as get order/{orderId}/order-item/{orderItemId}/garment-service-offer

// Delete all offers from one orderItem [DELETE]  : order/{orderId}/order-item/{orderItemId}/offer

// Delete single offer from one order-item [DELETE] : order/{orderId}/order-item/{orderItemId}/offer/{offerId}

// https://dhobicart.in/store/api/secure/v1/store/1/store-customer/2/garment-category-service-price/868'